// @ts-nocheck
import iconsIndex from "@store/Framework/Common/Hooks/IconIndex/iconsIndex";
import React, { useEffect, useState } from "react";
export type IconKey = keyof typeof iconsIndex;

const useIconIndex = (icon?: string | IconKey) => {
    const [iconComponent, setIconComponent] = useState<React.LazyExoticComponent<React.ComponentType<any>> | null>(
        null,
    );
    const iconNames = Object.keys(iconsIndex) as IconKey[];
    useEffect(() => {
        if (icon && iconsIndex?.[icon as IconKey]) {
            setIconComponent(React.lazy(iconsIndex[icon as IconKey] as any));
        }
    }, [icon]);
    return { iconComponent, iconNames };
};
export const iconOptions = Object.keys(iconsIndex)
    .sort()
    .map(icon => ({
        displayName: icon,
        value: icon,
    }));
export default useIconIndex;
